var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMore = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M20.0001 23.3334C21.841 23.3334 23.3334 21.841 23.3334 20C23.3334 18.1591 21.841 16.6667 20.0001 16.6667C18.1591 16.6667 16.6667 18.1591 16.6667 20C16.6667 21.841 18.1591 23.3334 20.0001 23.3334Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 23.3334C33.5075 23.3334 34.9999 21.841 34.9999 20C34.9999 18.1591 33.5075 16.6667 31.6666 16.6667C29.8256 16.6667 28.3333 18.1591 28.3333 20C28.3333 21.841 29.8256 23.3334 31.6666 23.3334Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 23.3334C10.1743 23.3334 11.6667 21.841 11.6667 20C11.6667 18.1591 10.1743 16.6667 8.33333 16.6667C6.49238 16.6667 5 18.1591 5 20C5 21.841 6.49238 23.3334 8.33333 23.3334Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/more.1d89c948.svg";
export { ForwardRef as ReactComponent };